'use client';

import { Button, useRequest } from '@wk/wk-uni-lib';
import { usePathname, redirect } from 'next/navigation';
import { useEffect } from 'react';

import { useLanguage } from '@/hooks/use-language';
import { getLanguage } from '@/utils/dictionary';
import Empty from 'public/images/common/empty.svg';

export default function NotFound() {
  const { currentLanguage } = useLanguage();
  const pathname = usePathname();
  const params = Promise.resolve({ lang: currentLanguage });
  const { data: dictionary } = useRequest(() => getLanguage(params, 'common'), {
    refreshDeps: [currentLanguage],
  });

  useEffect(() => {
    const timer = setTimeout(() => {
      redirect(`/${currentLanguage}/home`);
    }, 3000);

    return () => clearTimeout(timer);
  }, []);

  if (pathname === '/zh' || pathname === '/en') {
    redirect(`/${currentLanguage}/home`);
  }

  if (!dictionary) {
    return null;
  }

  return (
    <div className="flex min-h-screen items-center justify-center bg-[#F4F4EF]">
      <div className="text-center">
        <Empty className="mb-4 inline-block" />
        <h2 className="mb-4 text-2xl font-semibold text-gray-600">
          {dictionary['404-标题']}
        </h2>
        <p className="mb-6 text-gray-500">
          {dictionary['404-描述']}
          <br />
          {dictionary['404-描述2']}
        </p>
        <Button onClick={() => redirect(`/${currentLanguage}/home`)}>
          {dictionary['返回首页']}
        </Button>
      </div>
    </div>
  );
}
